/*
 * Candidate Finance Tab Messages
 *
 * This contains all the text for the Candidate Finance Tab component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.CandidatesDetailsPage.components.CandidateFinanceTab';

export default defineMessages({
  payrollAddress: {
    id: `${scope}.payrollAddress`,
    defaultMessage: 'Payroll Address',
  },
  taxData: {
    id: `${scope}.taxData`,
    defaultMessage: 'Tax Data',
  },
  healthInsurance: {
    id: `${scope}.healthInsurance`,
    defaultMessage: 'Health Insurance',
  },
  payrollDetails: {
    id: `${scope}.payrollDetails`,
    defaultMessage: 'Payroll Details',
  },
  street: {
    id: `${scope}.street`,
    defaultMessage: 'Street',
  },
  roomNumber: {
    id: `${scope}.roomNumber`,
    defaultMessage: 'Room Number',
  },
  town: {
    id: `${scope}.town`,
    defaultMessage: 'Town',
  },
  houseNumber: {
    id: `${scope}.houseNumber`,
    defaultMessage: 'House Number',
  },
  postCode: {
    id: `${scope}.postCode`,
    defaultMessage: 'Postcode',
  },
  country: {
    id: `${scope}.country`,
    defaultMessage: 'Country',
  },
  citizenship: {
    id: `${scope}.citizenship`,
    defaultMessage: 'Citizenship',
  },
  taxId: {
    id: `${scope}.taxId`,
    defaultMessage: 'Tax ID',
  },
  religion: {
    id: `${scope}.religion`,
    defaultMessage: 'Religion',
  },
  taxClass: {
    id: `${scope}.taxClass`,
    defaultMessage: 'Tax Class',
  },
  ucmAsMainEmployer: {
    id: `${scope}.ucmAsMainEmployer`,
    defaultMessage: 'UCM as a main employer',
  },
  socialSecurityNumber: {
    id: `${scope}.socialSecurityNumber`,
    defaultMessage: 'Social Security Number',
  },
  spouseReligion: {
    id: `${scope}.spouseReligion`,
    defaultMessage: 'Spouse Religion',
  },
  healthInsuranceType: {
    id: `${scope}.healthInsuranceType`,
    defaultMessage: 'Type',
  },
  healthInsuranceNumber: {
    id: `${scope}.healthInsuranceNumber`,
    defaultMessage: 'Number',
  },
  healthInsuranceProvider: {
    id: `${scope}.healthInsuranceProvider`,
    defaultMessage: 'Provider',
  },
  accountHolder: {
    id: `${scope}.accountHolder`,
    defaultMessage: 'Account Holder',
  },
  iban: {
    id: `${scope}.iban`,
    defaultMessage: 'IBAN',
  },
  bic: {
    id: `${scope}.bic`,
    defaultMessage: 'BIC',
  },
  identityCardNumber: {
    id: `${scope}.identityCardNumber`,
    defaultMessage: 'Identity Card Number',
  },
});
